export enum LockStatusEnum {
    PENDING = 'pending',
    ENROLLED = 'enrolled',
    ACTIVE = 'active',
    LOCKED = 'locked',
    UNLOCKED = 'unlocked',
    COMPLETED = 'completed'
}